import React from 'react'
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux";
import { selectProject } from '../../../redux/selectedProjectSlice';

import projectIcon1 from '../../../assets/images/project-icons/icon1.png'
import projectIcon2 from '../../../assets/images/project-icons/icon2.png'
import projectIcon3 from '../../../assets/images/project-icons/icon3.png'
import projectIcon4 from '../../../assets/images/project-icons/icon4.png'
import projectIcon5 from '../../../assets/images/project-icons/icon5.png'
import projectIcon6 from '../../../assets/images/project-icons/icon6.png'
import projectIcon7 from '../../../assets/images/project-icons/icon7.png'
import projectIcon8 from '../../../assets/images/project-icons/icon8.png'
import projectIcon9 from '../../../assets/images/project-icons/icon9.png'
import projectIcon10 from '../../../assets/images/project-icons/icon10.png'
import projectIcon11 from '../../../assets/images/project-icons/icon11.png'
import projectIcon12 from '../../../assets/images/project-icons/icon12.png'
import projectIcon13 from '../../../assets/images/project-icons/icon13.png'
import projectIcon14 from '../../../assets/images/project-icons/icon14.png'
import projectIcon15 from '../../../assets/images/project-icons/icon15.png'
import projectIcon16 from '../../../assets/images/project-icons/icon16.png'
import projectIcon17 from '../../../assets/images/project-icons/icon17.png'
import projectIcon18 from '../../../assets/images/project-icons/icon18.png'
import projectIcon19 from '../../../assets/images/project-icons/icon19.png'
import projectIcon20 from '../../../assets/images/project-icons/icon20.jpg'
import projectIcon21 from '../../../assets/images/project-icons/icon21.png'
import projectIcon22 from '../../../assets/images/project-icons/icon22.png'
import projectIcon23 from '../../../assets/images/project-icons/icon23.png'
import projectIcon24 from '../../../assets/images/project-icons/icon24.png'

export default function ProjectCard({ id, projectName, description, created_by, icon }) {
    const dispatch = useDispatch();
    const imagesForProjects = [projectIcon1, projectIcon2, projectIcon3, projectIcon4, projectIcon5, projectIcon6, projectIcon7, projectIcon8, projectIcon9, projectIcon10, projectIcon11, projectIcon12, projectIcon13, projectIcon14, projectIcon15, projectIcon16, projectIcon17, projectIcon18, projectIcon19, projectIcon20, projectIcon21, projectIcon22, projectIcon23, projectIcon24]
    return (
        <Link to={`/projects/${projectName}`} onClick={() => dispatch(selectProject({ id, name: projectName }))}>
            <div className="card project-card">
                <div className="project-card-wrap project-card-wrap-new">
                    <div className="project-card-left">
                        <img
                            // style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                            src={imagesForProjects[Number(icon?.slice(4)) - 1]}
                            // src={projectIcon10}
                            alt='icon'
                        />
                    </div>
                    <div className="project-card-right">
                        <h2>{projectName}</h2>
                        <p>{description}</p>
                        <div className="ownername align-items-center d-flex" style={{ gap: "5px" }}>
                            {created_by}
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}
